$(function () {
   gsap.registerPlugin(ScrollTrigger);

   //Hero Video
   const iframe = document.getElementById('r-hero-iframe');
   const player = new Vimeo.Player(iframe);

   player.on('loaded', function () {
      $('.r-hero-iframe').addClass('active');
   });

   gsap.utils.toArray(".scrolltrigger").forEach(section => {
      const snowflakes = section.querySelector(".r-snowflakes");

      gsap.set(snowflakes, { y: 0 });

      gsap.to(snowflakes, {
         y: 300,
         ease: "none",
         scrollTrigger: {
            trigger: section,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
            // markers: true,
            invalidateOnRefresh: true
         }
      });
   });

	//Vimeo Videos - GTM Tracking
	const iframes = document.querySelectorAll('iframe');
	const vimeoPlayers = [];
	iframes.forEach(function(el,index){
		var iframeURL = el.getAttribute('src');
		if (iframeURL.includes('vimeo') && !iframeURL.includes('background=1')){
			vimeoPlayers[index] = new Vimeo.Player(el);
			vimeoPlayers[index].on('play', function(){
				vimeoPlayers[index].getVideoId().then(function(id){
					// GTM: dataLayer Push
					pushGTM('play-vimeo',{
					'action' : 'Play',
					'video_id' : id
					});
				}).catch(function(error){
					// an error occurred
				});
			});
		}
	});

});

// ===================================================================
// Global Function to event and properties object to GTM dataLayer
// ===================================================================
function pushGTM(eventName,eventProperties){
	if (typeof window.dataLayer !== 'undefined'){
		if (typeof eventName === 'string' && typeof eventProperties === 'object'){
			eventName = eventName.replace(' ','-').replace('_','-');
			window.dataLayer.push({
				'event': 'JS - '+eventName,
				'js-event': eventProperties
			});
		}
	}
}